import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import PaginatedTable from "../../../components-bootstrap/PaginatedTable";
import { BodyBuilder, JuniorPlan } from "../../../../exports/Images";
import {
  convertThenFormat,
  formatDateTimezon,
} from "../../../common-data/Converts";
import TEPCard from "../common/TEPCard";

const PTPartialTabs = ({ partialInfo, setPartialInfo, setModValues }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const {
    partialTbData,
    pagination,
    pendingPartialTbData,
    pendingPagination,
    isPage,
    stats,
  } = partialInfo || {};

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    setPartialInfo((prevData) => ({
      ...prevData,
      isPage: 0,
    }));
  };

  const tbColumn = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150">{row?.gym_name || "NA"}</p>
        </div>
      ),
    },
    {
      dataField: "member_name",
      text: "Member Detail",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer">
          <img
            src={row?.member_profile || BodyBuilder}
            alt={row?.member_name || "NA"}
            className="image"
          />
          <p
            className="name hoverBlue info bold minWidth150 link"
            style={{
              fontWeight: 500,
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardType: "userDetailsModal",
                rowData: row,
              }));
            }}
          >
            {row?.member_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase", fontWeight: "500" }}>
              {row?.member_mobile || ""}
              <br />
              {row?.member_email || ""}
            </small>
          </p>
        </div>
      ),
    },
    {
      dataField: "trainer_name",
      text: "Trainer / Exp Level",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150 bold">
            {row?.trainer_name || "N/A"}
            <br />
            <span className="small-info" style={{ fontWeight: "500" }}>
              ( {row?.experience_level || "N/A"})
            </span>
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "price",
    //   text: "Amount/(Online,Cash)",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info minWidth150 bold">
    //         {row?.is_partial === "true"
    //           ? `₹${convertThenFormat(
    //               row?.total_partial_price || 0
    //             )} / ${convertThenFormat(row?.price || 0)}`
    //           : `₹${convertThenFormat(row?.price || 0)}`}
    //         <br />
    //         <small style={{ fontWeight: "500" }}>
    //           (₹
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_online
    //               : row?.total_online || 0
    //           )}{" "}
    //           /{" "}
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_cash
    //               : row?.total_cash || 0
    //           )}
    //           )
    //           <br />
    //           {row?.plan_name || ""}
    //         </small>
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "plan_name",
      text: "plan name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.plan_name || "NA"}</span>;
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className={`info ${row?.is_partial === "true" ? "link" : ""}`}
            onClick={() =>
              row?.is_partial === "true"
                ? setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardType: "partial_details",
                    partialDetails: row?.payment_details || [],
                  }))
                : null
            }
          >
            {row?.is_partial === "true" ? "Partial" : "Full"}
          </p>
        </div>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">₹{convertThenFormat(row?.price || 0)}</p>
        </div>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            {row?.is_partial === "true"
              ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
              : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_online
                : row?.total_online || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_cash
                : row?.total_cash || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "session_status",
      text: "session status/duration",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.session_status || "NA"}
          </p>
          <p className="info">{row?.duration || 0} Days</p>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "PT Date Added",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth100 bold">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "start_date",
      text: "Start/Expire Date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth90 bold">
            {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
            <br />
            {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "regular_subscription_status",
      text: "Regular Subscription status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background:
                row?.regular_subscription_status === "active"
                  ? "#B4E7B9"
                  : "#F6EFEF",
              color:
                row?.regular_subscription_status === "active"
                  ? "#0A701B"
                  : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.regular_subscription_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "subscription_status",
      text: "PT Subscription status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background:
                row?.subscription_status === "active" ? "#B4E7B9" : "#F6EFEF",
              color:
                row?.subscription_status === "active" ? "#0A701B" : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.subscription_status || "NA"}
          </p>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="cards-container cards-grid-container grid-3 ptFlow mt30">
        <TEPCard
          filterType={"total"}
          cardImg={JuniorPlan}
          totalAmount={`₹${convertThenFormat(stats?.total_amount || 0)}(${
            stats?.total_subscription || 0
          })`}
          cardTitle={"Total Partial Amount"}
          cardNotClickable={true}
        />
        <TEPCard
          filterType={"completed"}
          cardImg={JuniorPlan}
          totalAmount={`₹${convertThenFormat(
            stats?.total_partial_completed || 0
          )}`}
          cardTitle={"Partial Completed Amount"}
          cardNotClickable={true}
        />
        <TEPCard
          filterType={"pending"}
          cardImg={JuniorPlan}
          totalAmount={`₹${convertThenFormat(
            stats?.total_partial_upcoming || 0
          )}`}
          cardTitle={"Partial Pending Amount"}
          cardNotClickable={true}
        />
      </div>

      <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
        <TabList>
          <Tab>Completed partial Amount</Tab>
          <Tab>Pending partial Amount</Tab>
        </TabList>

        <TabPanel>
          <div className="fullWidthFlexCenter overflowAuto separatedTable">
            <PaginatedTable
              columnsValues={tbColumn}
              dataValues={partialTbData}
              paginationData={pagination}
              isPage={isPage}
              setIsPage={(value) =>
                setPartialInfo((prevData) => ({
                  ...prevData,
                  isPage: value,
                }))
              }
            />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="fullWidthFlexCenter overflowAuto separatedTable">
            <PaginatedTable
              columnsValues={tbColumn}
              dataValues={pendingPartialTbData}
              paginationData={pendingPagination}
              isPage={isPage}
              setIsPage={(value) =>
                setPartialInfo((prevData) => ({
                  ...prevData,
                  isPage: value,
                }))
              }
            />
          </div>
        </TabPanel>
      </Tabs>
    </>
  );
};

export default PTPartialTabs;
